import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Icon, H5, LetterAvatar, Avatar, Tooltip } from '../../../../../components';

const StyledH5 = styled(H5)`
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
`;

const AssetFooterSource = ({ source, showPlus = false, hideName = false }) => (
  <>
    <StyledH5 color='var(--content-subtitle)'>
      <Tooltip content={source.integration.displayName}>
        {source.integration.pictureUrl ? (
          <Avatar src={source.integration.pictureUrl} />
        ) : (
          <LetterAvatar size={24} name={source.integration.displayName} />
        )}
      </Tooltip>
      {!hideName && source.integration.displayName}
    </StyledH5>
    {showPlus && <Icon name='plus' size={20} displaySize={16} color='var(--content-subtitle)' />}
  </>
);

AssetFooterSource.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    integration: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      pictureUrl: PropTypes.string
    })
  }).isRequired,
  showPlus: PropTypes.bool,
  hideName: PropTypes.bool
};

export { AssetFooterSource };
